import React from "react";

const FEATURES = [
  { icon: "✅", label: "PEVO Certified Training" },
  { icon: "✅", label: "NPCA Recognized" },
  { icon: "✅", label: "All 50 States" },
  { icon: "✅", label: "Instant Digital Cert" },
  { icon: "✅", label: "Verified Driver Profiles" },
  { icon: "✅", label: "Live Load Board" },
];

export default function TrustStrip({ isDarkMode }) {
  const bg     = isDarkMode ? "#0f1c33"              : "#ffffff";
  const border = isDarkMode ? "rgba(255,255,255,0.08)": "#e2e8f0";
  const text   = isDarkMode ? "rgba(240,244,248,0.78)": "#475569";
  const green  = isDarkMode ? "#34d399"              : "#059669";

  return (
    <div style={{
      background:    bg,
      borderBottom:  `1px solid ${border}`,
      borderTop:     `1px solid ${border}`,
      padding:       "13px 24px",
      transition:    "background 0.3s, border-color 0.3s",
    }}>
      <div style={{
        maxWidth:       1200,
        margin:         "0 auto",
        display:        "flex",
        justifyContent: "space-around",
        alignItems:     "center",
        flexWrap:       "wrap",
        gap:            "10px 20px",
      }}>
        {FEATURES.map(({ icon, label }) => (
          <div key={label} style={{
            display:    "flex",
            alignItems: "center",
            gap:        6,
            fontSize:   13,
            fontWeight: 600,
            color:      text,
            whiteSpace: "nowrap",
            transition: "color 0.3s",
          }}>
            <span style={{ color: green, fontSize: 14 }}>✓</span>
            {label}
          </div>
        ))}
      </div>
    </div>
  );
}
